module.exports = __webpack_public_path__ + "img/valencia2.4be01084.jpg";